import { render, staticRenderFns } from "./TipoVeiculoList.vue?vue&type=template&id=2491c4a0&scoped=true"
import script from "./TipoVeiculoList.vue?vue&type=script&lang=js"
export * from "./TipoVeiculoList.vue?vue&type=script&lang=js"
import style0 from "./TipoVeiculoList.vue?vue&type=style&index=0&id=2491c4a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2491c4a0",
  null
  
)

export default component.exports